import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
  const navigate = useNavigate();

  // Read full user object
  const stored = localStorage.getItem("uid");
  const user = stored ? JSON.parse(stored) : null;

  if (!user) {
    return (
      <Box p={4} textAlign="center">
        <Typography variant="h6">You are not logged in.</Typography>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => navigate("/login")}
        >
          Go to Login
        </Button>
      </Box>
    );
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("uid");
    navigate("/login");
  };

  return (
    <Box p={4} display="flex" justifyContent="center">
      <Card sx={{ maxWidth: 400, width: "100%", boxShadow: 3, borderRadius: 3 }}>
        <CardContent>


   

          <Button
            variant="contained"
            color="error"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProfilePage;
